// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3_2eJ","content":"styles_content__KxrBt","selectAll":"styles_selectAll__1e00n"};